import { styled, css } from 'styled-components';
import { Media } from '../../../theme/Media';
import { DEFAULT_MODAL_ZINDEX } from '../../Feedback/Modal/constants';
const GAP = '8px';
export const DatePickerHeaderWrapper = styled.div `
  display: grid;
  grid-template-columns: 1fr 100px;
  gap: ${GAP};
  margin-bottom: ${GAP};

  @media ${Media.xsMax} {
    grid-template-columns: 1fr;
  }
`;
export const datePickerGlobalStyles = css `
  .react-datepicker-popper.adnz {
    z-index: ${DEFAULT_MODAL_ZINDEX + 50};

    @media ${Media.xsMax} {
      width: min(256px, calc(100vw - 40px)) !important;
    }

    .react-datepicker {
      ${({ theme: { shadows } }) => shadows.large};
      margin-top: 4px;
    }
  }

  .react-datepicker__aria-live {
    display: none;
  }

  ${({ theme: { colors, typography } }) => css `
    .react-datepicker {
      display: flex;
      background-color: ${colors.grey00_6};
      overflow: hidden;
      border-radius: 8px;

      @media ${Media.xsMax} {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
        padding: 12px;
        width: 100%;
        max-width: min(256px, calc(100vw - 40px));
      }
    }

    .react-datepicker__month-container {
      display: flex;
      flex-direction: column;
      padding: 12px;
      order: 1;
      width: 350px;

      &:not(:last-child) {
        border-right: 1px solid ${colors.grey10_1};
      }

      @media ${Media.xsMax} {
        width: auto;
        border: 1px solid ${colors.grey30_1};
        border-radius: 8px;
      }
    }

    .react-datepicker__children-container {
      order: 2;

      @media ${Media.xsMax} {
        order: 0;
      }
    }

    .react-datepicker__day-names {
      display: flex;
      border-radius: 8px;
      background-color: ${colors.grey01_1};
      padding: 5px 0;
      margin-bottom: ${GAP};
      justify-content: center;
      width: 100%;
    }

    .react-datepicker__day-name {
      width: calc(100% / 7);
      text-align: center;
      ${typography.textSmall};
      color: ${colors.grey100_1};
    }

    .react-datepicker__month {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      row-gap: calc(${GAP} / 2);
      width: 100%;
    }

    .react-datepicker__week {
      display: contents;
    }

    .react-datepicker__day {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;

      &:not(.react-datepicker__day--selected):not(.react-datepicker__day--disabled):hover {
        cursor: pointer;
      }

      &:not(.react-datepicker__day--in-range):not(.react-datepicker__day--in-selecting-range):not(.react-datepicker__day--disabled) {
        border-radius: 6px;

        &:not(.react-datepicker__day--selected):hover {
          background-color: ${colors.grey05_1};
        }
      }

      &:focus-visible {
        outline: 2px solid ${colors.main};
        outline-offset: 2px;
        border-radius: 6px;
      }
    }

    .react-datepicker__day--range-start.react-datepicker__day--in-range,
    .react-datepicker__day--keyboard-selected.react-datepicker__day--range-start,
    .react-datepicker__day--keyboard-selected.react-datepicker__day--selecting-range-start {
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }
    .react-datepicker__day--range-end.react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range) {
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }

    .react-datepicker__day--in-range {
      &:not(.react-datepicker__day--range-start):not(.react-datepicker__day--selecting-range-start) {
        &:not(.react-datepicker__day--range-end) {
          background-color: ${colors.mainLight};
          color: ${colors.black_3};
        }
      }
    }

    .react-datepicker__day--in-selecting-range {
      &:not(.react-datepicker__day--range-start):not(.react-datepicker__day--selecting-range-start) {
        &:not(.react-datepicker__day--range-end) {
          background-color: ${colors.mainLight};
          color: ${colors.black_3};
        }
      }
    }

    .react-datepicker__day--selecting-range-start,
    .react-datepicker__day--range-start,
    .react-datepicker__day--range-end,
    .react-datepicker__day--selected {
      background-color: ${colors.main};
      color: ${colors.grey00_2};
    }

    .react-datepicker__day--outside-month:not(.react-datepicker__day--in-range):not(.react-datepicker__day--selected) {
      color: ${colors.grey30_1};
    }

    .react-datepicker__day--disabled:not(.react-datepicker__day--in-range):not(.react-datepicker__day--selected) {
      color: ${colors.grey10_1};
      cursor: not-allowed;
    }

    .react-datepicker__triangle {
      display: none;
    }
  `}
`;
